import { filterParticipantsInOverlappingShifts } from './filterParticipantsInOverlappingShifts';
import { getShiftParticipantStorage } from './getShiftParticipantStorage';
export function areParticipantsInOverlappingShifts(context, shift, accountIds) {
    const filter = filterParticipantsInOverlappingShifts(shift, accountIds);
    const overlappingShiftParticipantsCount = getShiftParticipantStorage(context).count({ filter });
    return !overlappingShiftParticipantsCount;
}
